import React from "react";
import { useTranslation } from "react-i18next";
import { AppstoreOutlined } from "@ant-design/icons";
import "./TherapyCat.scss";

export function TherapyCat({ categories, selected, onSelect }) {
  const { t } = useTranslation("ui");

  return (
    <div className="revi-category-filter">
      <div className="filter-wrapper">
        <div className="cats-group">
          {/* TODAS (ahora dentro del mismo grupo => mismo centrado y misma altura) */}
          <div
            className={`filter-pill todas-btn ${selected === null ? "active" : ""}`}
            onClick={() => onSelect(null)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && onSelect(null)}
          >
            <div className="icon-wrapper">
              <AppstoreOutlined />
            </div>
            <span>{t("filtros.todas")}</span>
          </div>

          {/* Categorías */}
          {categories.map((cat) => {
            const isActive = selected === cat._id;
            return (
              <div
                key={cat._id}
                className={`filter-pill ${isActive ? "active" : ""}`}
                onClick={() => onSelect(cat._id)}
                style={{ color: isActive ? cat.colorCode : undefined }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && onSelect(cat._id)}
              >
                {cat.thumbnail ? (
                  <img src={cat.thumbnail} alt={cat.title} />
                ) : (
                  <div className="placeholder-icon" />
                )}
                <span>{cat.title}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
